import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Cache } from '../models/classes/cache';
import { SystemInfoModel } from '../models/classes/system-info';
import { DBPreCacheModel } from '../models/classes/db-precache';

@Injectable({
  providedIn: 'root',
})

export class DataService {
  ip = environment.ipServer;

  constructor(private http: HttpClient) {}

   startCaching(regionName) {
    const userUrl = `${this.ip}/api/getdata`;
    const url = `${userUrl}/${regionName}`;
    return  this.http.get<string>(url);
  }

   startReCaching(regionName) {
    const userUrl = `${this.ip}/api/ReCacheData`;
    const url = `${userUrl}/${regionName}`;
    return this.http.get<string>(url);
  }

  getDBPreCacheInfo(){
    const userUrl = `${this.ip}/api/DBPreCache/GetPreCacheInfo`;
    return this.http.get<DBPreCacheModel>(userUrl);
  }

  runDBPreCache() {
    const url = `${this.ip}/api/DBPreCache/ExecuteDBPreCache`;
    return this.http.post(url,'',{ observe: 'response' });
  }

  runRefreshSchema() {
    const url = `${this.ip}/api/SystemInfo/RefreshSchema`;
    return this.http.get<string>(url, { observe: 'response' }).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getStatus(regionName): Observable<Cache> {
    const url = `${this.ip}/api/cachestatus/GetCacheStatus/${regionName}`;
    return this.http.get<Cache>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getCachingStatus(regionName): Observable<number> {
    const url = `${this.ip}/api/GetCachingStatus/${regionName}`;
    return this.http.get<number>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getRegionStatus(region):Observable<boolean>{
    const url = `${this.ip}/api/GetRegionStatus/${region}`;
      return this.http.get<boolean>(url).pipe(
        tap((data) => data),
        catchError(this.handleError)
      );
  }

  getAboutStatus(): Observable<SystemInfoModel> {
    const url = `${this.ip}/api/SystemInfo/GetSchemaInfo`;
    return this.http.get<SystemInfoModel>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getLogs(): Observable<string[]> {
    const url = `${this.ip}/api/SystemInfo/GetLogs`;
    return this.http.get<string[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  getCacheLogs(): Observable<string[]> {
    const url = `${this.ip}/api/SystemInfo/GetCacheLogs`;
    return this.http.get<string[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  readLogs(name:string): Observable<string[]> {
    const url = `${this.ip}/api/SystemInfo/ReadLogs/${name}`;
    return this.http.get<string[]>(url);
  }

  readCacheLogs(name:string): Observable<string[]> {
    const url = `${this.ip}/api/SystemInfo/ReadCacheLogs/${name}`;
    return this.http.get<string[]>(url);
  }

  getRefreshStatus(){
    const url = `${this.ip}/api/RefreshStatus`;
    return this.http.get<number>(url);
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
